import React from 'react';

export const PreparationCallTabContent = () => <div>Preparation Call Tab Content</div>;
